<template>
  <div>
    <div class="container">
      <!-- 面包屑 -->
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('myInfo')">个人中心</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareGetList')">联储联备</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareGetList')">备件领用</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item">发货单详情</div>
      </div>
      <div class="sjz">
        <div :class="index===(steps.length-1)?'sjz-item':'sjz-kuaikuai'"
             v-for="(item, index) in steps"
             :key="index">
          <div class="sjz-item">
            <div :class="'sjz-icon '+ ((index>activeIndex)?'sjz-undone':(index===activeIndex)?'sjz-do':'')">
              <i class="el-icon-check"
                 style="width:40px;height:40px;"
                 v-if="index<activeIndex"></i>
              <span class="sjc-num sjc-do"
                    v-else-if="index===activeIndex">{{index+1}}</span>
              <span class="sjc-num"
                    v-else-if="index>activeIndex">{{index+1}}</span>
            </div>
            <div class="sjz-word">{{item.name}}</div>
            <div class="sjz-time">{{item.time}}</div>
          </div>
          <div :class="'sjz-line '+((index>=activeIndex)?'sjz-undone':'')"
               v-if="index!==(steps.length-1)"></div>
        </div>
      </div>
      <div class="body-info">
        <el-form :model="dataForm"
                 :inline="true"
                 ref="dataForm"
                 label-width="160px"
                 class="demo-form-inline"
                 v-if="detailInfo">
          <div style="position:relative;">
            <h3 style="display: inline-block;"
                class="spareInfo">基本信息</h3>
            <!-- <span v-if="detailInfo" style="position:absolute;right:30px;top:10px;padding:5px 20px;font-size: 14px;color: #333333;">
          领用单状态：
          <span v-if="detailInfo.status === '0'" style="color: #61BA00;">已提交</span>
          <span v-if="detailInfo.status === '1'" style="color: #61BA00;">发货中</span>
          <span v-if="detailInfo.status === '2'" style="color: #61BA00;">已签收</span>
          <span v-if="detailInfo.status === '3'" style="color: #61BA00;">已取消</span>
        </span> -->
          </div>
          <el-row>
            <el-col :span="9"
                    v-if="detailInfo"
                    class="row-height">
              <el-form-item label="公司名称："
                            prop="userName">
                <label>{{detailInfo.customerName}}</label>
              </el-form-item>
            </el-col>
            <el-col :span="9"
                    v-if="detailInfo"
                    class="row-height">
              <el-form-item label="收件人："
                            prop="userName">
                <label>{{addressInfo.receiveGoodsPerson}}</label>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-if="detailInfo"
                    class="row-height">
              <el-form-item label="联系电话："
                            prop="userName">
                <label>{{addressInfo.receiveGoodsPhone}}</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"
                    v-if="detailInfo"
                    class="row-height">
              <el-form-item label="收件地址："
                            prop="userName">
                <label>{{addressInfo.province}}-{{addressInfo.city}}-{{addressInfo.area}}-{{addressInfo.address}}</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"
                    v-if="detailInfo"
                    class="row-height">
              <el-form-item label="期望领用日期："
                            prop="userName">
                <label>{{detailInfo.expectDeliveryDate.substring(0,11)}}</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"
                    v-if="detailInfo">
              <el-form-item label="备注："
                            prop="userName">
                <label>{{detailInfo.remark}}</label>
              </el-form-item>
            </el-col>
          </el-row>
          <h3 style="display: inline-block;"
              class="spareInfo">领用物品</h3>
          <el-row style="margin-bottom:10px;"
                  v-for="(data, index) in dataList"
                  :key="index">
            <div class="row-title">
              <div class="row-arrow">
                <el-button type="size"
                           :icon="data.showContent ?'el-icon-arrow-up':'el-icon-arrow-down'"
                           @click="getmoreshow(index)"></el-button>
              </div>
              <div class="row-one">发货单号：{{data.deliverBillNo}}</div>
              <div>
                <span class="row-two">物流公司：{{data.expressCompany}}</span>
                <span>物流编号：{{data.expressNo}}</span>
              </div>
              <div v-if="data.status ==='0' && (detailInfo.status !== '2')"
                   :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                   class="row-btn"
                   @click="handleBatch(data.deliverId)">
                <i class="el-icon-loading"
                   v-if="subLoading"></i>
                确认收货
              </div>
              <div v-if="data.status ==='1'"
                   class="row-btn row-btn-check">
                已确认收货
              </div>
            </div>
            <el-table :data="data.detailVoList"
                      border
                      v-loading="dataListLoading"
                      v-if="data.showContent"
                      style="width: 100%; margin-top:10px">
              <el-table-column type="index"
                               width="50"
                               label="序号"></el-table-column>
              <el-table-column prop="oldGoodsCode"
                               header-align="center"
                               align="center"
                               label="物品编码"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldGoodsName"
                               header-align="center"
                               align="center"
                               label="物品名称"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldSpecification"
                               header-align="center"
                               align="center"
                               label="规格"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldModel"
                               header-align="center"
                               align="center"
                               label="型号"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldConfiguration"
                               header-align="center"
                               align="center"
                               label="配置"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldEdition"
                               header-align="center"
                               align="center"
                               label="版本"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldBrand"
                               header-align="center"
                               align="center"
                               label="品牌"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="oldRemark"
                               header-align="center"
                               align="center"
                               label="备注"
                               show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="deliverQuantity"
                               header-align="center"
                               align="center"
                               label="发货量"
                               show-overflow-tooltip>
              </el-table-column>
            </el-table>
            <div style="border:1px solid #ebeef5; margin-top:20px"></div>
          </el-row>
          <div class="row"
               style="display:flex;justify-content: center;margin-top:20px">
            <div :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="margin-right:10px;"
                 @click="handleCancel()">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              返回
            </div>
            <div :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="background-color:#1D65A8;color:#fff"
                 @click="handleSave()"
                 v-if="detailInfo.status === '5'">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              一键收货
            </div>
          </div>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      moreshow: false,
      count: 1,
      userInfo: null,
      detailInfo: null,
      receiveId: '',
      dataForm: {
        id: '',
        expectDeliveryDate: '',
        urgent: '1',
        remark: ''
      },
      addressList: [
        { name: 'XXX', address: '辽宁省大了事', phone: '15110989898' },
        { name: 'XXX1', address: '辽宁省大了事', phone: '15110989898' },
        { name: 'XXX12', address: '辽宁省大了事', phone: '15110989898' }
      ],
      gogo: true,
      currentIndex: '',
      visible: false,
      dataList: [],
      detailList: [],
      dataListLoading: false,
      dataListSelections: [],
      subLoading: false, // 按钮加载中
      subFlag: false, // 提交成功
      activeIndex: 0,
      steps: [
        {
          ind: 1,
          key: '',
          name: '提交领用',
          time: ''
        },
        {
          ind: 2,
          key: '',
          name: '仓储受理',
          time: ''
        },
        {
          ind: 3,
          key: '',
          name: '物流配送',
          time: ''
        },
        {
          ind: 4,
          key: '',
          name: '完成',
          time: ''
        },
        {
          ind: 5,
          key: '',
          name: '完成评价',
          time: ''
        }
      ],
      addressInfo: null
    }
  },
  mounted () {
    this.getInfo()
    this.getUserInfo()
    this.getDetailInfo()
    // this.getmoreshow()// 避免点击两次才生效
  },
  methods: {
    // 获取当前登录信息
    getUserInfo () {
      this.$http
        .get(`${window.SITE_CONFIG['baseURL']}/sys/user/info`)
        .then((data) => {
          // console.log(data)
          if (data && data.code === '1') {
            this.userInfo = data.result.user
          }
        })
    },
    // 跳转页面,取消返回
    routerHandle (name, pName) {
      if (name) {
        this.$router.push({ name: name })
      } else {
        this.resetData()
        this.$router.go(-1)
      }
    },
    // 获取信息
    getDetailInfo () {
      this.$http
        .get(
          `${window.SITE_CONFIG['baseURL']}/lclb/receive/info/${this.$route.query.id}`
        )
        .then((data) => {
          if (data && data.code === '1') {
            this.detailInfo = data.result.data
            this.addressInfo = data.result.data.addressVo
            // 状态(0 提交领用、1 仓储受理、5 物流配送、2 完成、4 评价)
            if (
              data.result.data.status === '0' ||
              data.result.data.status === '3'
            ) {
              this.activeIndex = 0
            }
            if (data.result.data.status === '1') {
              this.activeIndex = 1
            }
            if (data.result.data.status === '2') {
              this.activeIndex = 3
            }
            if (data.result.data.status === '5') {
              this.activeIndex = 2
            }
            if (data.result.data.status === '4') {
              this.activeIndex = 5
            }
            if (data.result.data.applyTime) {
              this.steps[0].time = data.result.data.applyTime
            }
            if (data.result.data.confirmTime) {
              this.steps[1].time = data.result.data.confirmTime
            }
            if (data.result.data.deliveryTime) {
              this.steps[2].time = data.result.data.deliveryTime
            }
            if (data.result.data.finishTime) {
              this.steps[3].time = data.result.data.finishTime
            }
            if (data.result.data.signTime) {
              this.steps[4].time = data.result.data.signTime
            }
          }
        })
    },
    // 获取发货单信息
    getInfo () {
      this.$http
        .get(
          `${window.SITE_CONFIG['baseURL']}/lclb/deliver/info/${this.$route.query.id}`
        )
        .then((data) => {
          if (data && data.code === '1') {
            this.dataList = data.result.data.deliverVo
            this.receiveId = data.result.data.receiveId
            this.dataList.forEach((item) => {
              item.showContent = true
            })
          }
        })
    },
    getmoreshow (index) {
      this.currentIndex = index
      var show = !this.dataList[index].showContent
      this.$set(this.dataList, index, {
        ...this.dataList[index],
        showContent: show
      })
    },
    deleteHandle (row, index) {
      this.dataList.splice(index, 1)
    },
    handleCancel () {
      this.$router.push({ name: 'spareGetList' })
    },
    // 按领用单号确认收货
    handleSave () {
      this.$http
        .post(`${window.SITE_CONFIG['baseURL']}/lclb/deliver/signed`, {
          receiveId: this.receiveId ? this.receiveId : null
        })
        .then((data) => {
          if (data.result.code === 0) {
            this.$message.success('确认收货成功')
            this.subLoading = false
            this.$router.push({ name: 'spareGetList' })
          } else {
            this.subLoading = false
          }
        })
        .catch(() => {
          this.subLoading = false
        })
    },
    // 按批次收货
    handleBatch (id) {
      this.subLoading = true
      this.$http
        .post(
          `${window.SITE_CONFIG['baseURL']}/lclb/deliver/signedByBatchNumber`,
          {
            deliverId: id
          }
        )
        .then((data) => {
          if (data.result.code === 0) {
            this.$message.success('确认收货成功')
            this.subLoading = false
            this.getInfo()
            this.getDetailInfo()
          } else {
            this.subLoading = false
          }
        })
        .catch(() => {
          this.subLoading = false
        })
    }
  }
}
</script>
<style scoped lang="scss">
.btns {
  margin-left: 230px;
}
.body-info h2 {
  font-size: 20px;
  color: #262626;
  margin-bottom: 20px;
}
.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 30px 30px;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}
.row-opt-but {
  width: 161px;
  height: 50px;
  border: 1px solid #1d65a8;
  background-color: #fff;
  color: #1d65a8;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.row-opt-but:hover {
  background-color: #1d65a8;
  color: #fff;
}
.but-loading {
  opacity: 0.5;
  cursor: not-allowed;
}
.status-btn {
  width: 100px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  margin-top: 10px;
  margin-left: 928px;
  background: #1d65a8;
  color: #fff;
}
.btn-check {
  margin-right: 30px;
}
.addressList {
  list-style: none;
}
.two-btns {
  margin-bottom: 10px;
}
.spareInfo {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 10px;
}
.inqueryDetail {
  .el-textarea {
    width: 100%;
    min-width: 500px;
  }
  .good-link {
    cursor: pointer;
    color: #1d65a8;
    text-decoration: underline;
  }
  /deep/ .el-form-item__label {
    flex-grow: 0;
    flex-shrink: 0;
  }
  /deep/ .el-form--inline .el-form-item,
  .el-form--inline .el-form-item__content {
    display: flex;
    word-break: break-all;
    word-wrap: break-word;
  }
}
.sjz {
  display: flex;
  justify-content: center;
  line-height: 40px;
  padding: 20px 70px;
  background-color: #fff;
}
.sjz-kuaikuai {
  display: flex;
  flex: 1;
}
.sjz-line {
  margin-top: 30px;
  flex: 1;
}
.sjz-item {
  width: 70px;
}
.sjz-icon {
  background: #ffffff;
  border: 1px solid #1d65a8;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin: 10px;
  margin-left: 15px;
  line-height: 38px;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
}
.sjz-icon .sjc-num {
  line-height: 34px;
  font-size: 16px;
  font-weight: normal;
}
.sjz-undone {
  color: #cacaca;
  border: 1px solid #cacaca;
}
.sjz-do {
  background-color: #1d65a8;
  color: #fff;
}
.sjz-icon .el-icon-check {
  font-size: 30px;
  line-height: 38px;
  font-weight: 900;
  color: #1d65a8;
}
.sjz-word {
  /* padding-left: 10px; */
  color: #1d65a8;
  text-align: center;
  width: 100%;
  line-height: 30px;
}
.sjz-time {
  color: #1d65a8;
  text-align: left;
  width: 130px;
  line-height: 20px;
  text-indent: -22px;
}
.sjz-line {
  height: 2px;
  background: #1d65a8;
  width: 20px;
}
.row-title {
  background: #ebebeb;
  height: 80px;
  width: 100%;
  font-size: 16px;
  padding-left: 15px;
  padding-top: 10px;
  border-bottom: 1px solid #ebebeb;
  position: relative;
}
.row-one {
  margin-bottom: 15px;
}
.row-two {
  margin-right: 150px;
}
.row-btn {
  position: absolute;
  right: 5px;
  top: 20px;
  height: 40px;
  line-height: 40px;
}
.row-btn-check {
  color: #000;
  font-size: 16px;
  right: 10px;
}
.row-arrow {
  float: left;
  margin-top: 7px;
  margin-right: 20px;
}
.row-height {
  height: 24px;
}
</style>
